export const SIGNIN = "signin";
export const DASHBOARD = "/";
export const SIGNUP = "Signup";
export const MESSAGES = "messages";
export const MESSAGE = "messages/:username";
export const PROFILE = "profile/:username";
export const POST = "post/:id";
export const NOT_FOUND = "not-found";
